import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AppConfigService {
    // private config: object = null;
    private configParameter: any;
    public scsAppSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private http: HttpClient) { }

    static getValue(target: any, key: string): any {

        if (!target) {
            return undefined;
        }

        const keys = key.split('.');
        key = '';

        do {
            key += keys.shift();
            const value = target[key];
            if (value !== undefined && (typeof value === 'object' || !keys.length)) {
                target = value;
                key = '';
            } else if (!keys.length) {
                target = undefined;
            } else {
                key += '.';
            }
        } while (keys.length);

        return target;
    }

    /**
     * Use to get the data found in the file (config file)
     */
    public get<T>(key: string, defaultValue?: any): T {
        const result: any = AppConfigService.getValue(this.configParameter, key);
        return (result === undefined ? defaultValue : result) as T;
    }

    /**
     * This method:
     *   Loads "config.json" to get all variables (e.g.: 'app.config.json')
     */
    load(): Promise<any> {
        return new Promise(async (resolve) => {
            const configUrl = `assets/app.config.json`;
            await this.http.get(configUrl).subscribe(
                (data: any) => {
                    this.configParameter = Object.assign({}, this.configParameter, data || {});
                    resolve(this.configParameter);
                },
                () => {
                    resolve(this.configParameter);
                }
            );
        });
    }
  
}